/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { shallowEqual, useSelector } from "react-redux";
import { forEach, get, isArray, isUndefined } from "lodash";
import DeleteIcon from "../../../assets/images/icon/delete-icon.svg";
// component
import BillForm from "../../../components/BillForm";
import Button from "../../../components/Button";
import Modal, { ModalHeader } from "../../../components/Modal";
import Radios from "../../../components/Radio/Radios";
import DataComponent from "../../../components/DataComponent";
import Comment from "../../../components/Comment";
import IconButton from "../../../components/Button/IconButton";
import SupplyCostCalculator from "../../../components/BillForm/SupplyCostCalculator";
import SelectClientInfo from "../../../components/BillForm/SelectClientInfo";
import DatePicker from "../../../components/DatePicker";
import SelectItemList from "../../../components/BillForm/SelectItem";
// hooks
import useForm from "../../../hooks/useForm";
// utils
import {
  dateToFormat,
  getDay,
  getYearMonthDay,
  monthDayFormat,
} from "../../../utils/date";
import systemAlert from "../../../utils/systemAlert";
import { toast } from "../../../utils/toast";
import { sortByKey } from "../../../utils/sort";
import { download } from "../../../utils/download";
import { excelUploadData } from "../../../utils/excelUploadData";
import { classnames } from "../../../utils/text";
import { restoreComma, transformComma } from "../../../utils/validator/comma";
import { cleanObj } from "../../../utils/cleanObj";
import { accountName } from "../../../utils/account-name";
// apis
import { getCompaniesDetail } from "../../../apis/companies/company-infos";
import { createInvoices, deleteInvoiceMappingTaxInvoice, deleteMappingCashReceipts, deleteToEtcInvoice, getInvoiceItemsExcelSample, getInvoices, modifyInvoices } from "../../../apis/invoices";
import { postFilesExcel } from "../../../apis/files";
import TaxInvoiceMapping from "./TaxInvoiceMapping";
import { autoHyphen } from "../../../utils/replace";
import { ControlTable } from "../../../components/Table";
import CashInvoiceMapping from "./CashInvoiceMapping";
import { getAccountsList } from "../../../apis/companies/account";
import Client from "../../Client/Client";
import { isEmpty } from "../../../utils/lodashExtend";
import EtcInvoiceMapping from "./EtcInvoiceMapping";
import SendEmailForm from "../SendEmailForm";
import { deleteBanksTransItems } from "../../../apis/finances/bank";

// invoicer 공급자
// invoicee 공급받는자
const TradeInvoice = ({
  open,
  setOpen,
  supByrType,
  formType,
  submit,
  permission,
  list = [],
  setList = () => { },
  setFormType = () => { },
  setInvoiceType = () => { },
}) => {
  const { user, permissions } = useSelector((store) => ({
    user: store.Profile.user,
    permissions: store.Profile.permissions
  }), shallowEqual);
  const [companyInfo, setCompanyInfo] = useState({});
  const [fields, setFields] = useState([]);
  // 품목 값
  const [initItemValues] = useState([
    {
      trMonth: new Date().getMonth() + 1,
      trDate: String(new Date().getDate()),
      prodName: "",
      unit: "",
      qty: "",
      unitCost: "",
      supplyCost: "",
      taxAmt: "",
      remark: "",
    },
  ]);
  const [itemValues, setItemValues] = useState([
    ...(!isEmpty(list[0]?.items) ? list[0].items : [{
      trMonth: new Date().getMonth() + 1,
      trDate: String(new Date().getDate()),
      prodName: "",
      unit: "",
      qty: "",
      unitCost: "",
      supplyCost: "",
      taxAmt: "",
      remark: "",
    }])
  ]);

  // 계산 state
  const [calculatorOpen, setCalculatorOpen] = useState(false);
  const [calculatorValue, setCalculatorValue] = useState({});
  const [calculItemIdx, setCalculItemIdx] = useState(0);
  // 거래처 불러오기
  const [clientSearchOpen, setClientSearchOpen] = useState(false);
  // 거래처 초기 검색 조건
  const [searchClientType, setSearchClientType] = useState('name');
  // 거래처 등록 모달 오픈
  const [accountOpen, setAccountOpen] = useState(false);
  const [accountDefaultAddForm, setAccountDefaultAddForm] = useState({});

  // 품목 불러오기
  const [itemSearchOpen, setItemSearchOpen] = useState(false);
  const [itemIdx, setItemIdx] = useState(0);
  // 세금계산서 매핑하기
  const [isTaxInvoiceMapping, setIsTaxInvoiceMapping] = useState(false);
  const [taxInvoiceMappingData, setTaxInvoiceMappingData] = useState(null);

  // 현금영수증 매핑하기
  const [isCashInvoiceMapping, setIsCashInvoiceMapping] = useState(false);
  const [cashInvoiceMappingData, setCashInvoiceMappingData] = useState(null);

  // 발주서/견적서 매핑하기
  const [isEtcInvoiceMapping, setIsEtcInvoiceMapping] = useState(false);
  const [etcInvoiceMappingData, setEtcInvoiceMappingData] = useState(null);

  // 은행내역 필드
  const [barnkTransfields] = useState([
    {
      title: "거래일자",
      key: "tradeTime",
      onValue: (value) => {
        return dateToFormat(value, "YYYY.MM.DD");
      },
    },
    {
      title: "계좌정보",
      key: "bankName",
      onValue: (_value, _field, data) =>
        data.bankAccount?.type === "cash_account" ? "기타거래" :
          accountName(data.bankName, data.bankAccountNo)
    },
    { title: "입금액", key: "inAmt", type: "comma" },
    { title: "출금액", key: "outAmt", type: "comma" },
    {
      title: "거래자명", key: "traderName"
    },
    {
      title: "입금자명", key: "sendBankAccountHolder"
    },
    {
      title: "적요", key: "remark"
    },
    {
      title: "적요(상세)", key: "detail"
    },
    {
      title: "메모", key: "memo"
    },
  ]);

  // 매핑된 계좌내역
  const [cashTransMappingData, setCashTransMappingData] = useState(null);
  const [bankTransMappingData, setBankTransMappingData] = useState(null);

  // 매핑된 세금계산서
  const [mappedTaxInvoiceFields, setMappedTaxInvoiceFields] = useState([]);
  const [mappedTaxInvoiceData, setMappedTaxInvoiceData] = useState([]);
  // 매핑된 종이세금계산서
  const [mappedPaperTaxInvoiceData, setMappedPaperTaxInvoiceData] = useState([]);
  // 매핑된 현금영수증
  const [mappedCashInvoiceFields, setMappedCashInvoiceFields] = useState([]);
  const [mappedCashInvoiceData, setMappedCashInvoiceData] = useState([]);
  // 매핑된 견적서/발주서
  const [mappedEtcInvoiceFields, setMappedEtcInvoiceFields] = useState([]);
  const [mappedEtcInvoiceData, setMappedEtcInvoiceData] = useState([]);

  // 현금영수증, 세금계산서, 거래처 권한
  const [cashInvoicePermission, setCashInvoicePermission] = useState({});
  const [taxInvoicePermission, setTaxInvoicePermission] = useState({});
  const [accountPermission, setAccountPermision] = useState({});

  // 메일 send
  const [emailOpen, setEmailOpen] = useState(false);

  useEffect(() => {
    if (!isEmpty(permissions)) {
      setCashInvoicePermission(permissions.find(p => p.code === 'CASH_INVOICE'));
      setTaxInvoicePermission(permissions.find(p => p.code === 'TAX_INVOICE'));
      setAccountPermision(permissions.find((p) => p.code === "COMPANY_ACCOUNT"));
    }
  }, [permissions]);

  useEffect(() => {
    setMappedTaxInvoiceFields([
      { title: "전송일자", key: "issueDate", type: 'date' },
      { title: "작성일자", key: "writeDate", type: 'date' },
      { title: "상호", key: supByrType === 'sales' ? "byrCorpName" : "supCorpName" },
      { title: "대표자명", key: supByrType === 'sales' ? "byrRepName" : "supRepName" },
      {
        title: "사업자번호",
        key: supByrType === 'sales' ? "byrBizNo" : "supBizNo",
        onValue: (value) => {
          return autoHyphen("comNum", value);
        },
      },
      { title: "대표품목", key: "itemName" },
      {
        title: "공급가액",
        key: "supplyAmt",
        type: 'comma'
      },
      {
        title: "세액",
        key: "taxAmt",
        type: 'comma'
      },
      {
        title: "합계금액",
        key: "totalAmt",
        type: 'comma'
      },
    ]);

    setMappedCashInvoiceFields([
      { title: "거래일자", key: "tradeTime", type: "date" },
      { title: "승인번호", key: "apprNo" },
      { title: "발급수단번호", key: "frPartNo" },
      { title: supByrType === 'sales' ? "거래구분" : "공제구분", key: supByrType === 'sales' ? "trGb" : "ddcYn" },
      { title: "공급가액", key: "supAmt", type: 'comma' },
      { title: "부가세", key: "taxAmt", type: 'comma' },
      { title: "봉사료", key: "tip", type: 'comma' },
      { title: "총 거래금액", key: "totAmt", type: 'comma' },
    ]);

    setMappedEtcInvoiceFields([
      { title: "전송일자", key: "issueDate", type: 'date' },
      { title: "작성일자", key: "writeDate", type: 'date' },
      { title: "상호", key: supByrType === 'sales' ? "byrCorpName" : "supCorpName" },
      { title: "대표자명", key: supByrType === 'sales' ? "byrRepName" : "supRepName" },
      {
        title: "사업자번호",
        key: supByrType === 'sales' ? "byrBizNo" : "supBizNo",
        onValue: (value) => {
          return autoHyphen("comNum", value);
        },
      },
      { title: "대표품목", key: "itemName" },
      {
        title: "공급가액",
        key: "supplyAmt",
        type: 'comma'
      },
      {
        title: "세액",
        key: "taxAmt",
        type: 'comma'
      },
      {
        title: "합계금액",
        key: "totalAmt",
        type: 'comma'
      },
    ]);

  }, [supByrType]);

  const _submit = (form) => {
    const dateInfo = getYearMonthDay(form.writeDate);
    for (const obj of itemValues) {
      if (isEmpty(obj.trMonth)) return toast.error("품목 거래 월을 입력해주세요");
      if (isEmpty(obj.trDate)) return toast.error("품목 거래 일을 입력해주세요");
      if (isEmpty(obj.prodName)) return toast.error("품목명을 입력해주세요");
      if (isEmpty(obj.supplyCost)) return toast.error("공급가액을 입력해주세요");
      if (isEmpty(obj.taxAmt) && form.taxType !== 'tax_free') return toast.error("세액을 입력해주세요");
    }

    // items
    const items = itemValues.map((value) => ({
      ...value,
      trDate: `${dateInfo.year}-${monthDayFormat(
        value.trMonth
      )}-${monthDayFormat(value.trDate)}`,
      qty: Number(value.qty),
      unitCost: Number(restoreComma(value.unitCost)),
      supplyCost: Number(restoreComma(value.supplyCost)),
      taxAmt: Number(restoreComma(value.taxAmt)),
    }));

    forEach(items, (item) => {
      setSearchClientType("name");
      delete item.trMonth;
      if (item.idx) {
        item.prodIdx = item.idx;
        delete item.idx;
      }
    });
    // formvalues
    const formValues = {
      ...form,
      totalAmt: Number(restoreComma(form.totalAmt)),
      supplyAmt: Number(restoreComma(form.supplyAmt)),
      taxAmt: Number(restoreComma(form.taxAmt)),
      writeDate: form.writeDate.toString(),
      items,
    };

    cleanObj(formValues);
    if (isEmpty(formValues.clientIdx)) {
      /**
       * @description
       * 1. 입력한 등록번호를 가진 거래처가 있는지 검색
       * 1-1. 있다면 거래처 불러오기 modal 열기
       * 1-2. 없다면 거래처 등록할건지 묻기
       * 거래처 등록을 진행한다면, 거래처 등록 modal 호출
       */

      setSearchClientType("comNum");
      getAccountsList({
        search: { comNum: `%${supByrType === 'sales' ? formValues.byrBizNo : formValues.supBizNo}%` }
      })
        .then(res => {
          if (get(res, "data.count") > 0) {
            handleGetClient();
          } else {
            if (!isEmpty(accountPermission)) {
              systemAlert(`입력한 정보의 거래처가 없습니다. 거래처 등록 후 진행하시겠습니까?`, {
                buttons: [
                  {
                    color: 'text',
                    label: '취소'
                  },
                  {
                    label: '등록하기',
                    onClick: () => {
                      setAccountOpen(true);
                      setAccountDefaultAddForm({
                        name: supByrType === 'sales' ? formValues.byrCorpName : formValues.supCorpName,
                        ceoName: supByrType === 'sales' ? formValues.byrRepName : formValues.supRepName,
                        comNum: supByrType === 'sales' ? formValues.byrBizNo : formValues.supBizNo,
                      });
                    }
                  }
                ]
              });
            } else {
              systemAlert("거래처 등록 권한이 없어 등록이 불가합니다.");
            }
          }
        });
    } else {
      if (formType === "create") {
        // 등록
        systemAlert(`${supByrType === "sales" ? "매출" : "매입"} 거래명세서를 등록하시겠습니까?`, {
          buttons: [
            {
              color: 'text',
              label: '취소'
            },
            {
              label: '확인',
              onClick: () => {
                createInvoices(formValues)
                  .then(() => {
                    setOpen(false);
                    setCompanyInfoByType();
                    setList({});
                    setFormType("");
                    setInvoiceType("");
                    setItemValues(initItemValues);
                    submit();
                    window.location.reload();
                  })
                  .catch((err) => {
                    console.error(err.response);
                  });
              }
            }
          ]
        });
      } else {
        // 수정
        const modifyForm = {
          clientIdx: formValues.clientIdx,
          supByrType: formValues.supByrType,
          taxType: formValues.taxType,
          supBizCategory: formValues.supBizCategory,
          supBizItem: formValues.supBizItem,
          writeDate: formValues.writeDate,
          supBizNo: formValues.supBizNo,
          supBizSubNo: formValues.supBizSubNo,
          supCorpName: formValues.supCorpName,
          supRepName: formValues.supRepName,
          supAddress: formValues.supAddress,
          byrBizNo: formValues.byrBizNo,
          byrBizSubNo: formValues.byrBizSubNo,
          byrCorpName: formValues.byrCorpName,
          byrRepName: formValues.byrRepName,
          byrAddress: formValues.byrAddress,
          totalAmt: formValues.totalAmt,
          supplyAmt: formValues.supplyAmt,
          taxAmt: formValues.taxAmt,
          remark: formValues.remark,
          supEmail: formValues.supEmail,
          byrEmail1: formValues.byrEmail1,
          byrEmail2: formValues.byrEmail2,
          memo: formValues.memo,
          items: formValues.items
        };
        cleanObj(modifyForm);
        systemAlert(`${supByrType === "sales" ? "매출" : "매입"} 거래명세서를 수정하시겠습니까?`, {
          buttons: [
            {
              color: 'text',
              label: '취소'
            },
            {
              label: '확인',
              onClick: () => {
                modifyInvoices(list.idx, modifyForm).then(() => {
                  setOpen(false);
                  setList({});
                  setFormType("");
                  setInvoiceType("");
                  setItemValues(initItemValues);
                  submit();
                  window.location.reload();
                });
              }
            }
          ]
        });
      }
    }
  };

  const validate = ({
    supBizNo,
    supCorpName,
    supRepName,
    byrBizNo,
    byrCorpName,
    byrRepName,
  }) => {
    let error = {};
    if (!supBizNo) error.supBizNo = "등록번호는 필수입니다.";
    if (!supCorpName) error.supCorpName = "상호는 필수입니다.";
    if (!supRepName) error.supRepName = "성명은 필수입니다.";
    if (!byrBizNo) error.byrBizNo = "등록번호는 필수입니다.";
    if (!byrCorpName) error.byrCorpName = "상호는 필수입니다.";
    if (!byrRepName) error.byrRepName = "성명은 필수입니다.";
    return error;
  };

  const { form, setForm, errors, handleOnChange, handleSubmit, setErrors, reset } =
    useForm(
      {
        clientIdx: null,
        supByrType,
        taxType: 'tax',
        supBizCategory: "",
        supBizItem: "",
        writeDate: getDay(),
        supBizNo: "",
        supBizSubNo: "",
        supCorpName: "",
        supRepName: "",
        supAddress: "",
        byrBizNo: "",
        byrBizSubNo: "",
        byrBizCategory: "",
        byrBizItem: "",
        byrCorpName: "",
        byrRepName: "",
        byrAddress: "",
        totalAmt: "",
        supplyAmt: "",
        taxAmt: "",
        remark: "",
        supEmail: "",
        byrEmail1: "",
        byrEmail2: "",
        memo: "",
        uploadFiles: "",
        items: "",
        ...(!isEmpty(list[0]) ? list[0] : {}),
      },
      _submit,
      validate
    );


  // 품목 리스트
  const [itemFields, setItemFields] = useState([]);

  useEffect(() => {
    setItemFields(
      [{
        title: "월",
        key: "trMonth",
        type: "input",
        textAlign: "center",
        options: {
          placeholder: "월",
        },
        required: true,
      },
      {
        title: "일",
        key: "trDate",
        type: "input",
        textAlign: "center",
        options: {
          placeholder: "일",
        },
        required: true,
      },
      {
        title: "품목",
        key: "prodName",
        type: "input",
        className: "prod-name",
        options: {
          placeholder: "품목입력",
        },
        required: true,
      },
      {
        title: "단위",
        key: "unit",
        type: "input",
        textAlign: "center",
        options: {
          placeholder: "단위",
        },
      },
      {
        title: "수량",
        key: "qty",
        type: "input",
        textAlign: "center",
        options: {
          placeholder: "수량",
        },
      },
      {
        title: "단가",
        key: "unitCost",
        type: "input",
        textAlign: "center",
        options: {
          placeholder: "단가",
        },
      },
      {
        title: "합계",
        key: "sumCostCalc",
        className: "print-out"
      },
      {
        title: "공급가액",
        key: "supplyCost",
        type: "input",
        textAlign: "center",
        options: {
          placeholder: "공급가액",
        },
        required: true,
      },
      ...(form.taxType !== 'tax_free' ? [
        {
          title: "세액",
          key: "taxAmt",
          type: "input",
          textAlign: "center",
          options: {
            placeholder: "세액",
          },
          required: true,
        },] : []),
      {
        title: "비고",
        key: "remark",
        type: "input",
        textAlign: "center",
        options: {
          placeholder: "비고",
        },
      }]
    );
  }, [form.taxType]);
  useEffect(() => {
    if (formType === "create") {
      setCompanyInfoByType();
    } else {
      if (!isEmpty(list)) {
        setInvoice(list);
      }
    }
  }, [supByrType, formType, list]);

  useEffect(() => {
    if (user) {
      getCompaniesDetail(user.companyIdx).then((res) => {
        setCompanyInfo(res.data.company);
      });
    }
  }, [user]);

  useEffect(() => {
    let supplyAmt = 0;
    let taxAmt = 0;

    forEach(itemValues, (value) => {
      supplyAmt += Number(restoreComma(value.supplyCost));
      if (form.taxType !== 'tax_free') {
        taxAmt += Number(restoreComma(value.taxAmt));
      }
    });

    const totalAmt = supplyAmt + taxAmt;
    setForm({
      ...form,
      totalAmt: transformComma(totalAmt),
      taxAmt: transformComma(taxAmt),
      supplyAmt: transformComma(supplyAmt),
    });
  }, [itemValues, form.taxType]);

  const setCompanyInfoByType = () => {
    switch (supByrType) {
      case "sales":
        setForm({
          ...(!isEmpty(list[0]) ? list[0] : {}),
          supByrType,
          supBizNo: companyInfo.comNum,
          supBizSubNo: companyInfo.sectNum,
          supCorpName: companyInfo.name,
          supRepName: companyInfo.ceoName,
          supAddress: isEmpty(companyInfo.address) ? "" : isEmpty(companyInfo.addressDetail) ? companyInfo.address : `${companyInfo.address} ${companyInfo.addressDetail}`,
          supBizCategory: companyInfo.bsnType,
          supBizItem: companyInfo.bsnSect,
          supEmail: companyInfo.taxEmail,
        });
        break;
      case "purchase":
        setForm({
          ...form,
          supByrType,
          byrBizNo: companyInfo.comNum,
          byrBizSubNo: companyInfo.sectNum,
          byrCorpName: companyInfo.name,
          byrRepName: companyInfo.ceoName,
          byrAddress: isEmpty(companyInfo.address) ? "" : isEmpty(companyInfo.addressDetail) ? companyInfo.address : `${companyInfo.address} ${companyInfo.addressDetail}`,
          byrBizCategory: companyInfo.bsnType,
          byrBizItem: companyInfo.bsnSect,
          byrEmail1: companyInfo.taxEmail,
        });
        break;
      default:
        break;
    }
  };

  useEffect(() => {
    setFields([
      [
        {
          title: "작성일자",
          key: "writeDate",
          type: "datepicker",
          className: "write-date",
          labelClassName: "font-size-13",
          disabled: formType === "detail",
        },
        {
          title: "비고",
          key: "memo",
          type: "input",
          className: "font-size-13",
          options: {
            placeholder: "비고 입력",
            disabled: formType === "detail",
          },
        },
      ],
      [
        {
          title: "합계금액",
          key: "totalAmt",
          type: "input",
          className: "font-size-13",
          textAlign: "right",
          options: {
            placeholder: "0",
            disabled: true,
          },
        },
        {
          title: "공급가액",
          key: "supplyAmt",
          className: "font-size-13",
          type: "input",
          textAlign: "right",
          options: {
            placeholder: "0",
            disabled: true,
          },
        },
        ...(form.taxType !== 'tax_free' ? [{
          title: "세액",
          key: "taxAmt",
          className: "font-size-13",
          textAlign: "right",
          type: "input",
          options: {
            placeholder: "0",
            disabled: true,
          },
        },] : [])
      ],
    ]);
  }, [form, formType, itemValues]);

  useEffect(() => {
    if (formType !== "detail") {
      forEach(itemValues, (itemVal) => {
        itemVal.trMonth = dateToFormat(form.writeDate.toString(), "M");
      });
    }
  }, [form, formType]);

  const cancel = (e) => {
    e.preventDefault();
    setOpen(false);
    setList({});
    setFormType("");
    setInvoiceType("");
    setItemValues(initItemValues);
    setErrors({});
    reset();
  };

  const handleGetClient = () => {
    setClientSearchOpen(true);
  };

  const uploadExcelFile = (e) => {
    const file = e.target.files[0];
    if (!isUndefined(file)) {
      const formData = new FormData();
      formData.append("file", file);
      postFilesExcel(formData)
        .then((res) => {
          const rows = get(res, "data.sheets[0].rows");
          const keys = [
            { idx: 1, key: "prodName", type: String },
            { idx: 2, key: "qty", type: String },
            { idx: 3, key: "unit", type: String },
            { idx: 4, key: "unitCost", type: Number },
            { idx: 5, key: "supplyCost", type: Number },
            { idx: 6, key: "taxAmt", type: Number },
            { idx: 7, key: "tradeDate", type: Date },
            { idx: 8, key: "remark", type: String },
          ];

          const excelData = {
            products: excelUploadData({ keys, rows }),
          };

          setItemValues(excelData.products.map((d) => ({
            trMonth: String(new Date(d.tradeDate).getMonth() + 1),
            trDate: String(new Date(d.tradeDate).getDay()),
            prodName: d.prodName,
            unit: d.unit,
            qty: d.qty,
            unitCost: transformComma(d.unitCost),
            supplyCost: transformComma(d.supplyCost),
            taxAmt: transformComma(d.taxAmt),
            remark: d.remark,
          })));
        });
    }
  };

  const itemHeaderButtons = [
    {
      label: (
        <>
          샘플다운로드 <i className="mdi mdi-arrow-collapse-down" />
        </>
      ),
      color: "gray-line",
      size: "sm",
      action: () => {
        getInvoiceItemsExcelSample().then((res) => {
          download(res.data.url);
        });
      },
    },
    {
      label: "엑셀업로드",
      type: "excelFile",
      size: "sm",
      onChange: (e) => uploadExcelFile(e),
    },
    {
      label: "품목 추가",
      color: "line",
      size: "sm",
      action: () => {
        // 품목 추가
        setItemValues((oldVal) => [
          ...oldVal,
          {
            trMonth: dateToFormat(form.writeDate.toString(), "M") || new Date().getMonth() + 1,
            trDate: String(new Date().getDate()),
            prodName: "",
            unit: "",
            qty: "",
            unitCost: "",
            supplyCost: "",
            taxAmt: "",
            remark: "",
          },
        ]);
      },
    },
  ];

  // 품목 change
  const handleOnChangeItemList = (e, idx) => {
    const { name, value } = e.target;
    const originValues = [...itemValues];
    let changedItemValues = originValues[idx];

    if (name === "unitCost" || name === "supplyCost" || name === "taxAmt") {
      changedItemValues = {
        ...changedItemValues,
        [name]: transformComma(value),
      };
    } else {
      changedItemValues = {
        ...changedItemValues,
        [name]: value,
      };
    }

    if (['unitCost', 'qty'].includes(e.target.name)) {
      if (!isEmpty(changedItemValues.qty) && !isEmpty(changedItemValues.unitCost)) {
        // 기본으로 부가세 미포함 금액 적용.
        const qty = Number(changedItemValues.qty);
        const unitCost = Number(restoreComma(changedItemValues.unitCost));
        const supplyCost = qty * unitCost;
        const taxAmt = Math.ceil(supplyCost * 0.1);

        changedItemValues = {
          ...changedItemValues,
          supplyCost: transformComma(supplyCost),
          taxAmt: transformComma(taxAmt)
        };
      }
    }

    originValues[idx] = changedItemValues;
    setItemValues(originValues);
  };

  // 품목 삭제
  const handleOnRemoveItem = (idx) => {
    // 품목 값 삭제
    setItemValues(() => [
      ...itemValues.filter((values, valueIndex) => valueIndex !== idx),
    ]);
  };

  const setInvoice = (data) => {
    // 거래명세서 상세 조회
    getInvoices(data.idx).then((res) => {
      setForm(res.data);
      setMappedTaxInvoiceData((res.data?.mappedTaxInvoices || []).filter(f => f.invoiceType !== "paper_tax_invoice"));
      setMappedPaperTaxInvoiceData((res.data?.mappedTaxInvoices || []).filter(f => f.invoiceType === "paper_tax_invoice"));
      setMappedEtcInvoiceData(res.data?.mappedEtcInvoices);
      const cashTrans = (res.data?.registeredBankTrans || []).filter(item =>
        item.bankAccount?.type === "cash_account");

      const bankTrans = (res.data?.registeredBankTrans || []).filter(item =>
        item.bankAccount?.type !== "cash_account");

      setCashTransMappingData(cashTrans);
      setBankTransMappingData(bankTrans);

      if (supByrType === 'sales') {
        setMappedCashInvoiceData(res.data?.mappedSalesCashReceipts);
      } else {
        setMappedCashInvoiceData(res.data?.mappedPurchaseCashReceipts);
      }
      const sortedItemList = sortByKey(res.data?.invoiceItems, "order");
      const transItemValue = [];
      for (const obj of sortedItemList) {
        const date = getYearMonthDay(obj.trDate);
        transItemValue.push({
          prodIdx: obj.prodIdx,
          trMonth: monthDayFormat(date.month),
          trDate: monthDayFormat(date.day),
          prodName: obj.prodName,
          unit: obj.unit,
          qty: String(obj.qty),
          unitCost: transformComma(obj.unitCost),
          supplyCost: transformComma(obj.supplyCost),
          taxAmt: transformComma(obj.taxAmt),
          remark: obj.remark,
        });
      }
      setItemValues(transItemValue);
    });
  };

  const mappedTaxInvoiceRowBtnConfig = {
    title: '삭제',
    rowButtons: [
      {
        // 거래처 매핑
        type: "delete",
        action: (data) => {
          systemAlert(`연관 ${data.invoiceType === "paper_tax_invoice" ? "종이" : "전자"}(세금)계산서를 삭제하시겠습니까?`, {
            buttons: [
              {
                color: 'text',
                label: '취소'
              },
              {
                label: '확인',
                onClick: () => {
                  deleteInvoiceMappingTaxInvoice({ idxes: [data.invoiceToTaxInvoice.idx] })
                    .then(() => {
                      setInvoice(list);
                    })
                    .catch(() => { })
                    .finally(() => { });
                }
              }
            ]
          });
        },
      },
    ],
  };

  const mappedCashInvoiceRowBtnConfig = {
    title: '삭제',
    rowButtons: [
      {
        type: "delete",
        action: (data) => {
          systemAlert('연관 현금영수증을 삭제하시겠습니까?', {
            buttons: [
              {
                color: 'text',
                label: '취소'
              },
              {
                label: '확인',
                onClick: () => {
                  deleteMappingCashReceipts({ idxes: [data.invoiceToCashReceipt.idx] })
                    .then(() => {
                      setInvoice(list);
                    })
                    .catch(() => { })
                    .finally(() => { });
                }
              }
            ]
          });
        },
      },
    ],
  };

  const mappedEtcInvoiceRowBtnConfig = {
    title: '삭제',
    rowButtons: [
      {
        type: "delete",
        action: (data) => {
          systemAlert('연관 견적서/발주서를 삭제하시겠습니까?', {
            buttons: [
              {
                color: 'text',
                label: '취소'
              },
              {
                label: '확인',
                onClick: () => {
                  deleteToEtcInvoice("invoice", { idx: [data.invoiceToEtcInvoice?.idx] })
                    .then(() => {
                      setInvoice(list);
                    }).catch(() => { })
                    .finally(() => { });
                }
              }
            ]
          });
        },
      },
    ],
  };

  const addAccountSubmit = (data) => {
    const account = data.account;
    const {
      idx,
      name,
      comNum,
      ceoName,
      address = "",
      addressDetail = "",
      industryType = "",
      industrySect = "",
      sectNum = "",
      email = "",
      taxEmail1 = "",
      taxEmail2 = "",
    } = account;

    if (supByrType === "sales") {
      setForm({
        ...form,
        clientIdx: idx,
        byrBizNo: comNum,
        byrBizSubNo: sectNum,
        byrCorpName: name,
        byrRepName: ceoName,
        byrAddress: isEmpty(address) ? "" : isEmpty(addressDetail) ? address : `${address} ${addressDetail}`,
        byrBizCategory: industryType,
        byrBizItem: industrySect,
        byrEmail1: taxEmail1 || email,
        byrEmail2: taxEmail2,
      });
    } else {
      setForm({
        ...form,
        clientIdx: idx,
        supBizNo: comNum,
        supBizSubNo: sectNum,
        supCorpName: name,
        supRepName: ceoName,
        supAddress: isEmpty(address) ? "" : isEmpty(addressDetail) ? address : `${address} ${addressDetail}`,
        supBizCategory: industryType,
        supBizItem: industrySect,
        supEmail: taxEmail1 || taxEmail2 || email,
      });
    }

    setAccountDefaultAddForm({});
  };

  const mappedBankTransRowBtnConfig = {
    title: "삭제",
    rowButtons: [
      {
        type: "delete",
        action: (data) => {
          systemAlert(`연관 거래내역을 삭제하시겠습니까?`, {
            buttons: [
              {
                color: "text",
                label: "취소"
              },
              {
                label: "확인",
                onClick: () => {
                  deleteBanksTransItems(data?.bankTransItem?.idx)
                    .then(() => {
                      setInvoice(list);
                    }).catch(() => { })
                    .finally(() => { });
                }
              }
            ]
          });
        },
      },
    ]
  };

  return (
    <>
      <Modal isOpen={open} close={cancel} size="x-lg" className="p-0">
        <div className="trade-invoice-write">
          <ModalHeader>
            {supByrType === "sales" ? "매출" : "매입"} 거래명세서
          </ModalHeader>
          <div className="header-button-wrap">
            {formType !== 'create' && (
              <>
                <Button
                  className="print-button print-out"
                  color="gray-line"
                  label="인쇄"
                  onClick={() => window.print()}
                />

                <Button
                  className="print-button print-out ml-8"
                  label='메일 전송'
                  color='gray-line'
                  onClick={() => {
                    setEmailOpen(true);
                  }}
                />

                {permission.level > 1 && (
                  <>
                    <Button
                      className="print-button print-out ml-8"
                      color="gray-line"
                      label="현금영수증 매핑"
                      disabled={isEmpty(cashInvoicePermission)}
                      onClick={() => {
                        setIsCashInvoiceMapping(true);
                        setCashInvoiceMappingData(list);
                      }}
                    />
                    <Button
                      className="print-button print-out ml-8"
                      color="gray-line"
                      label="세금계산서 매핑"
                      disabled={isEmpty(taxInvoicePermission)}
                      onClick={() => {
                        setIsTaxInvoiceMapping(true);
                        setTaxInvoiceMappingData(list);
                      }}
                    />
                    <Button
                      className="print-button print-out ml-8"
                      color="gray-line"
                      label="견적서/발주서 매핑"
                      disabled={false}
                      onClick={() => {
                        setIsEtcInvoiceMapping(true);
                        setEtcInvoiceMappingData(list);
                      }}
                    />
                  </>
                )}
              </>
            )}
          </div>
          <div className="trade-invoice-body">
            <div className="bill-form-header">
              <label className="tax-type-label">종류</label>
              <Radios
                field={{
                  key: "taxType",
                  defaultChecked: form.taxType,
                  onChange: handleOnChange,
                  options: {
                    list: [
                      { label: "과세", value: "tax" },
                      { label: "면세", value: "tax_free" },
                      { label: "영세", value: "small_biz" },
                    ],
                  },
                }}
                disabled={formType === "detail"}
              />
              {formType !== "detail" && (
                <Button
                  color="line"
                  label="거래처 불러오기"
                  size="sm"
                  className="float-right print-out"
                  action={handleGetClient}
                />
              )}
            </div>
            <div className="bill-form-body">
              <div className="invoicer-bill">
                <BillForm
                  type="sup"
                  form={form}
                  onChange={handleOnChange}
                  errors={errors}
                  formType={formType}
                />
              </div>
              <div className="invoicee-bill">
                <BillForm
                  type="byr"
                  form={form}
                  onChange={handleOnChange}
                  errors={errors}
                  formType={formType}
                />
              </div>
              {isArray(fields) &&
                fields.map((_fields, index) => (
                  <table className="bill-additional-form" key={index}>
                    <tbody>
                      <tr>
                        {isArray(_fields) &&
                          _fields.map((field, idx) => (
                            <React.Fragment key={idx}>
                              <td className="additional-form-title">
                                {field.title}
                              </td>
                              <td className="additional-form-input">
                                {field.type === "datepicker" ? (
                                  <>
                                    <DatePicker
                                      field={field}
                                      defaultValue={form.writeDate}
                                      onChange={(date) => {
                                        setForm({ ...form, ...date });
                                        const trDate = dateToFormat(date.writeDate[0], "D");
                                        const newItemValues = itemValues.map(item => ({
                                          ...item,
                                          trDate
                                        }));
                                        setItemValues(newItemValues);

                                      }}
                                    />
                                    <span className="write-date-description">
                                      ※ 작성일자는 공급연월일을 의미함
                                    </span>
                                  </>
                                ) : (
                                  <DataComponent
                                    field={field}
                                    form={form}
                                    className={field.className}
                                    onChange={handleOnChange}
                                  />
                                )}
                              </td>
                            </React.Fragment>
                          ))}
                      </tr>
                    </tbody>
                  </table>
                ))}
            </div>
            <div className="item-list-container">
              <div className="item-list-header">
                <p className="item-list-description">
                  ※ 품목의 월은 작성일자의 월이 표시되고 변경은 작성일자 수정시
                  자동 반영됨
                </p>
                {formType !== "detail" && (
                  <div className="header-button-wrap print-out">
                    {itemHeaderButtons.map((button, idx) => (
                      <DataComponent
                        key={idx}
                        field={{
                          type: "button",
                          ...button,
                        }}
                      />
                    ))}
                  </div>
                )}
              </div>
              <div className="item-list">
                <table>
                  <thead>
                    <tr>
                      {!isEmpty(itemFields) && itemFields.map((item, idx) => (
                        <th key={idx} className={item.className}>
                          <span className={classnames("item-table-header", { required: item.required })}>{item.title}</span>
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {itemValues.map((item, idx) => (
                      <tr key={idx}>
                        {!isEmpty(itemFields) && itemFields.map((_item, index) => (
                          <td key={index} className={_item.className}>
                            {_item.key !== "sumCostCalc" && (
                              <DataComponent
                                className={_item.className}
                                field={_item}
                                onChange={(e) => handleOnChangeItemList(e, idx)}
                                form={itemValues[idx]}
                                disabled={formType === "detail"}
                              />
                            )}
                            {_item.key === "prodName" && (
                              <DataComponent
                                field={{
                                  type: "button",
                                  label: "불러오기",
                                  size: "x-sm",
                                  color: "line",
                                  className: "float-right print-out",
                                  disabled: formType === "detail",
                                  action: () => {
                                    setItemSearchOpen(true);
                                    setItemIdx(idx);
                                  }
                                }}
                              />
                            )}
                            {_item.key === "sumCostCalc" && (
                              <Button
                                color="line"
                                size="x-sm"
                                label="계산"
                                disabled={formType === 'detail'}
                                action={() => {
                                  if (
                                    isEmpty(itemValues[idx].qty) ||
                                    isEmpty(itemValues[idx].unitCost)
                                  ) {
                                    if (isEmpty(itemValues[idx].unitCost)) {
                                      systemAlert("단가를 입력해주세요");
                                    }
                                    if (isEmpty(itemValues[idx].qty)) {
                                      systemAlert("수량을 입력해주세요");
                                    }
                                    return;
                                  }
                                  setCalculItemIdx(idx);
                                  setCalculatorValue(itemValues[idx]);
                                  setCalculatorOpen(true);
                                }}
                              />
                            )}
                          </td>
                        ))}
                        <td className="print-out">
                          {itemValues.length > 1 && (
                            <IconButton
                              icon={DeleteIcon}
                              className="delete-btn"
                              disabled={formType === "detail"}
                              onClick={() => handleOnRemoveItem(idx)}
                            />
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
            {formType !== 'create' && (
              <>
                {/* <div className="registered-trans-wrap print-out">
                  {!isEmpty(list.registeredBankTrans) && (
                    <>
                      <p className="title">
                        연관된 은행내역
                      </p>
                      <table>
                        <thead>
                          <tr>
                            {barnkTransfields.map((field, idx) => <th key={idx}>{field.title}</th>)}
                          </tr>
                        </thead>
                        <tbody>
                          {list.registeredBankTrans.map((trans, index) => (
                            <tr key={index}>
                              {barnkTransfields.map((field, idx) => (
                                <td key={idx} className="vertical-align-middle">
                                  <DataComponent field={field} data={trans} />
                                </td>
                              ))}
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </>
                  )}
                  
                </div> */}
                {!isEmpty(bankTransMappingData) && (
                  <div className="mapped-tax-invoice-container">
                    <label className="related-header-title">
                      연관 은행계좌 거래내역
                    </label>
                    <ControlTable fields={barnkTransfields} list={bankTransMappingData} rowBtn={permission.level > 1 ? mappedBankTransRowBtnConfig : {}} />
                  </div>
                )}
                {!isEmpty(cashTransMappingData) && (
                  <div className="mapped-tax-invoice-container">
                    <label className="related-header-title">
                      연관 기타거래 거래내역
                    </label>
                    <ControlTable fields={barnkTransfields} list={cashTransMappingData} rowBtn={permission.level > 1 ? mappedBankTransRowBtnConfig : {}} />
                  </div>
                )}
                {!isEmpty(mappedTaxInvoiceData) && (
                  <div className="mapped-tax-invoice-container">
                    <label className="related-header-title">
                      연관 전자(세금)계산서
                    </label>
                    <ControlTable fields={mappedTaxInvoiceFields} list={mappedTaxInvoiceData} rowBtn={permission.level > 1 ? mappedTaxInvoiceRowBtnConfig : {}} />
                  </div>
                )}
                {!isEmpty(mappedPaperTaxInvoiceData) && (
                  <div className="mapped-tax-invoice-container">
                    <label className="related-header-title">
                      연관 종이(세금)계산서
                    </label>
                    <ControlTable fields={mappedTaxInvoiceFields} list={mappedPaperTaxInvoiceData} rowBtn={permission.level > 1 ? mappedTaxInvoiceRowBtnConfig : {}} />
                  </div>
                )}
                {!isEmpty(mappedCashInvoiceData) && (
                  <div className="mapped-tax-invoice-container">
                    <label className="related-header-title">
                      연관 현금영수증
                    </label>
                    <ControlTable fields={mappedCashInvoiceFields} list={mappedCashInvoiceData} rowBtn={permission.level > 1 ? mappedCashInvoiceRowBtnConfig : {}} />
                  </div>
                )}
                {!isEmpty(mappedEtcInvoiceData) && (
                  <div className="mapped-tax-invoice-container">
                    <label className="related-header-title">
                      연관 견적서/발주서
                    </label>
                    <ControlTable fields={mappedEtcInvoiceFields} list={mappedEtcInvoiceData} rowBtn={permission.level > 1 ? mappedEtcInvoiceRowBtnConfig : {}} />
                  </div>
                )}
                <div className="file-upload-list">
                  <label className="file-upload-label">첨부파일</label>
                  <div className="file-upload-form">
                    <Comment
                      postIdx={list.idx}
                      postType="invoice_detail"
                      submit={submit}
                    />
                  </div>
                </div>
              </>
            )}
            <div className="submit-button-wrap float-right print-out">
              <Button
                className="button"
                size="lg"
                label="취소"
                color="text"
                action={cancel}
              />
              {(formType === "create" || formType === "modify") && (
                <Button
                  className="button"
                  size="lg"
                  label={formType === "create" ? "작성완료" : "수정완료"}
                  action={handleSubmit}
                />
              )}
            </div>
          </div>
        </div>
      </Modal>
      {/* 거래처 불러오기 */}
      {clientSearchOpen && (
        <SelectClientInfo
          open={clientSearchOpen}
          setOpen={setClientSearchOpen}
          type={supByrType}
          form={form}
          setForm={setForm}
          searchType={searchClientType}
        />
      )}
      {/* 품목 조회 */}
      {itemSearchOpen && (
        <SelectItemList
          open={itemSearchOpen}
          setOpen={setItemSearchOpen}
          form={itemValues}
          setForm={setItemValues}
          itemIdx={itemIdx}
          isSales={supByrType === "sales" ? true : false}
        />
      )}
      {/* 공급가액 계산 */}
      {calculatorOpen && (
        <SupplyCostCalculator
          open={calculatorOpen}
          setOpen={setCalculatorOpen}
          data={calculatorValue}
          itemValues={itemValues}
          setItemValues={setItemValues}
          idx={calculItemIdx}
        />
      )}
      {/* 세금계산서 매핑하기 */}
      {isTaxInvoiceMapping && (
        <TaxInvoiceMapping
          open={isTaxInvoiceMapping}
          setOpen={setIsTaxInvoiceMapping}
          data={taxInvoiceMappingData}
          setData={setTaxInvoiceMappingData}
          type={supByrType}
          listSubmit={() => setInvoice(list)}
        />
      )}
      {/* 현금영수증 매핑하기 */}
      {isCashInvoiceMapping && (
        <CashInvoiceMapping
          open={isCashInvoiceMapping}
          setOpen={setIsCashInvoiceMapping}
          data={cashInvoiceMappingData}
          setData={setCashInvoiceMappingData}
          type={supByrType}
          listSubmit={() => setInvoice(list)}
        />
      )}
      {/* 거래처 등록하기 */}
      {accountOpen && !isEmpty(accountDefaultAddForm) && (
        <Client
          permission={accountPermission}
          open={accountOpen}
          setOpen={setAccountOpen}
          defaultAddForm={accountDefaultAddForm}
          addAccountSubmit={addAccountSubmit}
        />
      )}

      {/* 견적서or발주서 매핑하기 */}
      {isEtcInvoiceMapping && (
        <EtcInvoiceMapping
          open={isEtcInvoiceMapping}
          setOpen={setIsEtcInvoiceMapping}
          data={etcInvoiceMappingData}
          setData={setEtcInvoiceMappingData}
          listSubmit={() => setInvoice(list)}
          requesterType={"invoice"}
        />
      )}

      {/* 이메일 발송하기 */}
      {emailOpen && (
        <SendEmailForm
          open={emailOpen}
          setOpen={setEmailOpen}
          data={list}
          type={"invoice"}
        />
      )}
    </>
  );
};

export default TradeInvoice;
